import {defaultPreferencesFields} from '../notificationFields/utils/constants';

export const defaultPOCFields = {
  preferences: defaultPreferencesFields
};
